/**
 * BandarQQ domain types.
 * Mirrors packages/amgbandarqq_v2 game constants — 9 bet positions
 * (291-299), Player/Banker/Tie outcome, 28 distinct dominoes.
 */

export type GamePhase =
  | 'idle'
  | 'initializing'
  | 'modeSelection'
  | 'betting'
  | 'bettingClosed'
  | 'waitingResult'
  | 'dealing'
  | 'showResult'
  | 'result'
  | 'newRound'
  | 'error';

/** Server bet-item IDs — see bandarqq_flame_game.dart:15-25. */
export const BET_ITEM_IDS = [
  291, 292, 293, 294, 295, 296, 297, 298, 299,
] as const;
export type BetItemId = (typeof BET_ITEM_IDS)[number];

/** Convert a server bet id to the 1..9 box index used by Rive (rive_controller_manager.dart:81-91). */
export const BET_ID_TO_BOX_INDEX: Record<BetItemId, number> = {
  291: 1,
  293: 2,
  299: 3,
  292: 4,
  294: 5,
  297: 6,
  296: 7,
  298: 8,
  295: 9,
};

export const BOX_INDEX_TO_BET_ID: Record<number, BetItemId> = (() => {
  const out: Record<number, BetItemId> = {};
  for (const id of BET_ITEM_IDS) {
    out[BET_ID_TO_BOX_INDEX[id]] = id;
  }
  return out;
})();

/** Game winner — derived from #red / #blue domino-pip scores. */
export type GameResult = 'playerWin' | 'bankerWin' | 'tie';

export interface GameConfig {
  minBet: number;
  maxBet: number;
  chipValues: readonly number[];
}

export interface GameRound {
  roundId: string;
  nextRoundId: string;
  playerScore: number;
  bankerScore: number;
  winner: GameResult;
  winningBetIds: BetItemId[];
  /** 4 indices in [0..27] — [redA, redB, blueA, blueB]. */
  dominoSpriteIndices: number[];
  needsShuffle: boolean;
  totalWinLose: number;
  totalBet: number;
  positiveWinAmount: number;
  hasPositiveWin: boolean;
}

export function isBetItemId(n: number): n is BetItemId {
  return (BET_ITEM_IDS as readonly number[]).includes(n);
}
